<template>
  <el-dialog
    title="转账信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="200px"
      size="small"
    >

      <el-form-item
              prop="state"
              label="审核是否通过"
      >
        <el-radio v-model="form.state" label="0"  >通过</el-radio>
        <el-radio v-model="form.state" label="1"  >不通过</el-radio>
      </el-form-item>

      <el-form-item
              prop="return_msg"
              label="备注"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.return_msg"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >提交</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import * as oneclassService from '@/api/sys/oneclass'
import util from '@/libs/util.js'
export default {
  name: 'smallposterEditForm',
  props: {
    oneclass: Object,
    value: Boolean
  },
  data () {
    return {

      formEdit: true,
      loading: false,
      dialogVisible: false,
      form: {
        state: '0',
        return_msg: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
    },

    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.saveAccountGlj({ ...this.form, agentid: util.cookies.get('agentid'), xt_id: util.cookies.get('xt_id'), id: this.oneclass.id })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
